<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> รายละเอียด
        </div>
        <div class="d-flex justify-end">
          <Button
            :disabled="editMode"
            @onClick="addProduct"
            theme="500"
            prepend-icon="mdi-plus"
            >ผลิตภัณฑ์</Button
          >
        </div>
      </div>
      <div class="txt-head black--text mb-2">
        1. ผลิตภัณฑ์ (Product)
        <span class="txt-normal theme-color-seven">(โปรดระบุ)</span>
      </div>
      <div class="card-part">
        <div class="d-flex gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 10%; max-width: 10%">จัดการ</div>
          <div class="flex" style="min-width: 20%; max-width: 20%">
            ผลิตภัณฑ์
          </div>
          <div class="flex" style="min-width: 70%; max-width: 70%">
            รูปผลิตภัณฑ์
          </div>
        </div>
        <div
          v-if="form.spider_chart_2_1 && form.spider_chart_2_1.length > 0"
          class="d-flex flex-column gap-12"
        >
          <divcard
            v-for="(item, i) in form.spider_chart_2_1"
            :key="i"
            class="plan-card d-flex justify-space-between gap-8"
          >
            <div
              class="d-flex align-center"
              style="min-width: 10%; max-width: 10%"
            >
              <v-btn small icon @click="editProduct(i)">
                <Iconify
                  icon="material-symbols:edit"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
              <v-btn small icon @click="deleteProduct(i)">
                <Iconify
                  icon="material-symbols:delete"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
            <div class="flex text-break" style="min-width: 20%; max-width: 20%">
              {{ item.product_name ?? "-" }}
            </div>
            <div class="flex text-break" style="min-width: 70%; max-width: 70%">
              {{
                (item?.attachment?.name || item?.attachment?.file_name) ?? "-"
              }}
            </div>
          </divcard>
        </div>
        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
      <div v-if="editMode" class="pt-6">
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
          </div>

          <v-layout class="mt-3">
            <template
              v-if="
                !productNew?.attachment?.doc_type ||
                productNew?.attachment?.doc_type === null
              "
            >
              <v-flex xs7>
                <v-file-input
                  v-model="files"
                  :id="'file'"
                  :rules="rulesFile"
                  color="#F15A29"
                  :clearable="false"
                  style="border-radius: 30px"
                  outlined
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="image/png"
                  v-show="
                    checkValType(productNew?.attachment?.file_name) ==
                      'object' ||
                    productNew?.attachment?.file_name == '' ||
                    productNew?.attachment?.file_name == null
                  "
                  @change="addToAttachment(files)"
                ></v-file-input>
                <v-text-field
                  v-show="
                    checkValType(productNew?.attachment?.file_name) == 'string'
                  "
                  v-model="productNew.attachment.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                  depressed
                  dark
                  rounded
                  width="100"
                  color="#464647"
                  @click="selectFile()"
                >
                  <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                  <span class="font-12 font-w-700">อัพโหลด</span>
                </v-btn>
              </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                  depressed
                  height="35"
                  width="35"
                  fab
                  dark
                  color="#FD0C0C"
                  @click="removeFile()"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-flex>
            </template>
          </v-layout>
        </div>
        <div>
          <div class="mb-1 black--text">ผลิตภัณฑ์</div>
          <TextField
            theme="3"
            :value="productNew.product_name"
            @onChange="productNew.product_name = $event"
          >
          </TextField>
        </div>
        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="
              editMode = false;
              productNew = {};
            "
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveProduct"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        2. กิจกรรมที่จะเกิดขึ้นภายในอาคาร
        <span class="txt-normal theme-color-seven">(โปรดระบุ)</span>
      </div>
      <TextArea
        theme="3"
        :height="120"
        :value="form.activity"
        @onChange="
          form.activity = $event;
          $forceUpdate();
        "
      >
      </TextArea>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        3. กิจกรรมสนับสนุนสำหรับอุทยานวิทยาศาสตร์
      </div>
      <div class="d-flex justify-end">
        <Button
          :disabled="editMode2"
          @onClick="addSupport"
          theme="500"
          prepend-icon="mdi-plus"
          >ประเภท</Button
        >
      </div>
      <div class="card-part">
        <div class="d-flex gap-8 px-3 mb-3">
          <div class="flex" style="min-width: 10%; max-width: 10%">จัดการ</div>
          <div class="flex" style="min-width: 60%; max-width: 60%">
            ประเภทการบริการ
          </div>
          <div class="flex" style="min-width: 30%; max-width: 30%">
            อัตราค่าบริการ
          </div>
        </div>
        <div
          v-if="form.spider_chart_2_3 && form.spider_chart_2_3.length > 0"
          class="d-flex flex-column gap-12"
        >
          <divcard
            v-for="(item, i) in form.spider_chart_2_3"
            :key="i"
            class="plan-card d-flex justify-space-between gap-8"
          >
            <div
              class="d-flex align-center"
              style="min-width: 10%; max-width: 10%"
            >
              <v-btn small icon @click="editSupport(i)">
                <Iconify
                  icon="material-symbols:edit"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
              <v-btn small icon @click="deleteSupport(i)">
                <Iconify
                  icon="material-symbols:delete"
                  color="var(--theme-color-seven)"
                ></Iconify>
              </v-btn>
            </div>
            <div class="flex" style="min-width: 60%; max-width: 60%">
              {{ item.service_type ?? "-" }}
            </div>
            <div class="flex" style="min-width: 30%; max-width: 30%">
              {{ item.service_price }}
            </div>
          </divcard>
        </div>
        <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
      </div>
      <div v-if="editMode2" class="pt-6">
        <div>
          <div class="mb-1 black--text">ประเภทการบริการ</div>
          <TextField
            theme="3"
            :value="supportNew.service_type"
            @onChange="supportNew.service_type = $event"
          >
          </TextField>
        </div>
        <div>
          <div class="mb-1 black--text">อัตราค่าบริการ</div>
          <TextField
            theme="3"
            :value="supportNew.service_price"
            @onChange="supportNew.service_price = $event"
          >
          </TextField>
        </div>
        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="
              editMode2 = false;
              supportNew = {};
            "
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveSupport"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        4. เสถียรภาพทางการเงิน (Financial stability)
      </div>
      <div>
        <div class="mb-1 black--text">เสถียรภาพทางการเงิน</div>
        <TextField
          theme="3"
          :value="form.financial_stability"
          @onChange="
            form.financial_stability = $event;
            $forceUpdate();
          "
        >
        </TextField>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        5. ความร่วมมือที่ผ่านมา (Past cooperation)
      </div>
      <div>
        <div class="mb-1 black--text">ความร่วมมือที่ผ่านมา</div>
        <TextField
          theme="3"
          :value="form.past_cooperation"
          @onChange="
            form.past_cooperation = $event;
            $forceUpdate();
          "
        >
        </TextField>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextArea from "../../components/input/TextArea";
import TextField from "../../components/input/TextField";
import SwitchInset from "../../components/input/SwitchInset";
import AutoBox from "../../components/input/AutoBox";
import Button from "@/components/input/Button";
import CheckBox from "../../components/input/CheckBox";
import DatePicker from "../../components/input/DatePicker";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    CheckBox,
    DatePicker,
    TextArea,
  },
  data() {
    return {
      form: {
        spider_chart_2_1: [],
        spider_chart_2_3: [],
      },
      files: [],
      productNew: {},
      supportNew: {},
      editMode: false,
      editMode2: false,

      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
      websiteRules: [
        (v) => !!v || "",
        (v) => /^(http|https):\/\/[^ "]+$/.test(v) || "เว็บไซต์ไม่ถูกต้อง",
      ],
      zipCodeRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 5) || "รหัสไปรษณีย์ต้องมี 5 หลัก",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      pidRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 13) || "เลขประจำตัวประชาชนต้องมี 13 หลัก",
      ],
    };
  },
  props: {
    masterData: Object,
    formData: Object,
  },
  created() {
    eventBus.$on("spiderChart2", () => {
      eventBus.$emit("spiderChart2Send", {
        ...this.form,
        updated_by: "1",
        created_by: "1",
      });
    });
    eventBus.$emit("spiderChart2Send", {
      ...this.form,
      updated_by: "1",
      created_by: "1",
    });
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = {
          spider_chart_2_1: Array.isArray(newValue.spider_chart_2_1)
            ? newValue.spider_chart_2_1
            : [],
          spider_chart_2_3: Array.isArray(newValue.spider_chart_2_3)
            ? newValue.spider_chart_2_3
            : [],
          ...JSON.parse(JSON.stringify(newValue)), // Clone the rest of the data
        };
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    addProduct() {
      this.editMode = true;
      this.productNew = {
        isNew: true,
        attachment: [{
          file_name: null,
        }],
      };
    },
    saveProduct() {
      if (!this.productNew.isNew) {
        this.form.spider_chart_2_1[this.productNew.temp_index] =
          this.productNew;
      } else {
        this.form.spider_chart_2_1.push(this.productNew);
      }
      this.files = [];
      this.productNew = {
        attachment: [
          {
            file_name: null,
          },
        ],
      };
      this.editMode = false;
    },
    editProduct(i) {
      this.editMode = false;
      this.files = this.form.spider_chart_2_1[i]?.attachment || {
        file_name: null,
      };
      this.productNew = {
        ...this.removeVModel(this.form.spider_chart_2_1[i]),
        temp_index: i,
        isNew: false,
        attachment: this.files,
      };
      this.editMode = true;
      this.$forceUpdate();
    },
    deleteProduct(i) {
      this.form.spider_chart_2_1.splice(i, 1);
      this.$forceUpdate();
    },

    addSupport() {
      this.editMode2 = true;
      this.supportNew.isNew = true;
    },
    saveSupport() {
      if (!this.supportNew.isNew) {
        this.form.spider_chart_2_3[this.supportNew.temp_index] =
          this.supportNew;
      } else {
        this.form.spider_chart_2_3.push(this.supportNew);
        console.log(this.form.spider_chart_2_3);
      }
      this.supportNew = {};
      this.editMode2 = false;
    },
    editSupport(i) {
      this.editMode2 = false;
      this.supportNew = {
        ...this.removeVModel(this.form.spider_chart_2_3[i]),
        temp_index: i,
        isNew: false,
      };
      this.editMode2 = true;
      this.$forceUpdate();
    },
    deleteSupport(i) {
      this.form.spider_chart_2_3.splice(i, 1);
      this.$forceUpdate();
    },

    addToAttachment(file) {
      console.log("file size", file.size);
      //check if file size > 10mb then show dialog modal

      const allowedTypes = [
        "image/png", // Only allow PNG files
      ];

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        this.$store.commit("General/setModal", {
          title: "ประเภทไฟล์ไม่ถูกต้อง",
          theme: "warning",
          text: "กรุณาแนบเฉพาะไฟล์ PNG",
          showCancel: false,
          buttonText: "ตกลง",
        });
        // Remove the last file
        this.productNew.attachment = [
          {
            file_name: null,
          },
        ];
        this.files = [];
        return;
      }

      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.productNew.attachment = [
          {
            file_name: null,
          },
        ];
        this.files = [];
        return;
      }
      this.productNew.attachment = file || [ {  file_name: null,} ];
      console.log("addToAttachment", this.productNew.attachment);
    },
    removeFile() {
      this.productNew.attachment = [];
      this.files = [];
    },
    selectFile() {
      document.querySelector("#file").click();
    },
    checkValType(val) {
      return typeof val;
    },
  },
};
</script>

<style></style>
